export type FaqType = {
  question: string;
  answer: any;
  id: string;
};

export const ReloadCardFaq = (): FaqType[] => {
  return [
    {
      id: 'question_1',
      question: 'What is the validity of your Forex card?',
      answer:
        'Your Forex multi-currency card is valid for 5 years from the date of issue. Post this, you will need to reissue a new card against the same credentials.',
    },
    {
      id: 'question_2',
      question: 'What should I do if my Forex card is stolen or lost?',
      answer:
        'In case your Forex card is stolen or is lost, contact our customer care team immediately at 1800 102 1616. Also, opt-in for a replacement card to be delivered. This replacement Forex card can be delivered PAN India with a nominal fee. Please not that at Muthoot FinCorp ONE, we also issue a backup Forex card along with your purchase so that you can avoid the inconvenience and be hassle-free, in case your primary card is stolen or lost.  However, please make sure to place a request to deactivate the primary Forex card and activate the backup Forex card, when you start using the replacement or secondary card.',
    },
    {
      id: 'question_3',
      question: 'How can I block or deactivate my Forex card?',
      answer:
        'You can block your Muthoot FinCorp ONE multi-currency Forex card through our telephonic assistance. Just call our Forex card partner Thomas Cook on 1800-2099-100 and place a request to block or deactivate your card',
    },
    {
      id: 'question_4',
      question: 'Can I load multiple currencies in the Forex card?',
      answer:
        '. The Muthoot FinCorp ONE Forex card is a multi-currency card. You can load multiple currencies in your Forex card and it will automatically select the accepted currency at ATMS, POS etc.',
    },
    // {
    //   id: 'question_5',
    //   question: 'How can I reload my Forex card?',
    //   answer:
    //     'ou can reload your Muthoot FinCorp ONE Forex card on the go and online. Go to the Muthoot FinCorp ONE website, click on reload card and make your payment online. Once your order is completed, we will recharge your card within 24* hours.',
    // },
    // {
    //   id: 'question_6',
    //   question: 'Can I unload my Forex card?',
    //   answer:
    //     'Yes, you can unload your Muthoot FinCorp ONE Forex card online or by visiting the nearest Muthoot FinCorp Forex branch to convert the remaining balance into INR instantly.',
    // },
  ];
};

export const BuyForexFaq = (): FaqType[] => {
  return [
    {
      id: 'question_1',
      question: 'How can I purchase Forex from Muthoot FinCorp ONE?',
      answer:
        'Muthoot FinCorp ONE offers all major and legally accepted currencies. You can buy from our list of offered currencies by logging in and choosing your preferred currency. You can also schedule an appointment to get Forex at nearby Muthoot FinCorp Forex branch and get your currency hassle-free at the booked price.',
    },
    {
      id: 'question_2',
      question:
        'What are the documents required to purchase Forex from Muthoot FinCorp ONE?',
      answer:
        'If you are an Indian resident, we would need to verify your proof of address (Aadhar Card / Driving Licence / Passport / Voter ID) along with KYC. Whereas, for foreign residents, they need to submit their passport and VISA.',
    },
    {
      id: 'question_3',
      question: 'Can I choose the denomination for my Forex cash?',
      answer:
        'Currently we do not offer the option to select cash denominations.',
    },
  ];
};

export const SellForexFaq = (): FaqType[] => {
  return [
    {
      id: 'question_1',
      question:
        ' How can I sell my left-over Forex cash at Muthoot FinCorp ONE?',
      answer:
        'At Muthoot FinCorp ONE you can choose the currency online you want to sell and then book an appointment online to visit the nearest Muthoot FinCorp Forex branch. Submit your documents at the branch, at the appointed time and get money instantly transferred to your bank account.',
    },
    {
      id: 'question_2',
      question: 'Can I also sell foreign exchange coins?',
      answer:
        'Yes, Muthoot FinCorp branch also accepts coins along with currency notes.',
    },
    {
      id: 'question_3',
      question:
        'Can I exchange Forex currency at Muthoot FinCorp branch even though I have not purchased the same from you?',
      answer:
        'Yes, at Muthoot FinCorp branch, we accept Forex currency even if you have not purchased from us.',
    },
    {
      id: 'question_4',
      question:
        'Can I exchange torn or soiled Forex notes at Muthoot FinCorp branch?',
      answer: 'At Muthoot FinCorp branch we do not accept torn or soiled notes',
    },
    // {
    //   id: 'question_5',
    //   question:
    //     'What is the documentation required for selling Forex to Muthoot FinCorp?',
    //   answer:
    //     'If you are a foreign resident, we would need a copy of your passport along with VISA and if you are an Indian resident, we would require your KYC documents (Aadhar Card/Driving Licence/Pan Card/Passport/Voter ID). Please note that VISA is mandatory in both cases.',
    // },
  ];
};

export const LandingPageFaq = (): FaqType[] => {
  return [
    {
      id: 'question_1',
      question: 'What is the limit of international money transfer in a year?',
      answer:
        'The limit for international money transfers set by the Reserve Bank of India under Liberalized Remittance Scheme (LRS) is USD 2,50,000  in one financial year.',
    },
    {
      id: 'question_2',
      question:
        'Do I need to visit a Muthoot FinCorp Branch to purchase Forex/Outward remittance/Forex card?',
      answer: (
        <>
          Muthoot FinCorp ONE gives you the option to apply for your
          multi-currency Forex card online and get it delivered at home. You can
          also send money abroad (remittance) and reload your existing Muthoot
          FinCorp ONE Forex card, both online and offline.
          <br />
          However, in case you wish to collect cash or sell foreign currency,
          you will have to visit your nearest Muthoot FinCorp Forex branch.
        </>
      ),
    },
    {
      id: 'question_3',
      question:
        'What are the different purposes allowed by RBI for which I can purchase Forex ?',
      answer: (
        <>
          RBI allows the following purposes for which you can purchase Forex for
          non-trade accounts
          <br />
          (a) Private visits <br />
          (b) Remittance by tour operators / travel agents to overseas agents
          /overseas principals (international entity approved by financial
          regulatory authority of that country for carrying on money transfer
          activities)/hotels <br />
          (c) Business travels <br />
          (d) Fees for participation in global conferences and specialized
          trainings, <br />
          (e) Remittance for participation in international events/competitions
          (towards training, sponsorship and prize money), <br />
          (f) Film shoots <br />
          (g) Medical treatment abroad <br />
          (h) Disbursement of crew wages <br />
          (i) Overseas education <br />
          (j) Remittance under educational tie up arrangements with universities
          abroad <br />
          (k) Remittance towards fees for examinations held in India and abroad,
          along with additional scoresheets for GRE, TOEFL, etc. <br />
          (l) Employment and processing, assessment fees for overseas job
          applications, <br />
          (m) Emigration and emigration consultancy fees, <br />
          (n) Skills/credential assessment fees for intending migrants <br />
          (o) Visa fees <br />
          (p) Processing fees for registration of documents as required by the
          Portuguese and other Governments <br />
          (q) Registration /subscriptions / membership fees to International
          Organisations.
        </>
      ),
    },
    // {
    //   id: 'question_4',
    //   question: 'What all payment methods can I use to purchase Forex?',
    //   answer:
    //     'At Muthoot FinCorp ONE we accept online payment methods – Net-banking, bank transfer, UPI and debit cards. In addition to the above, we accept cash as well at the Muthoot FinCorp branch, only if the order value is less than Rs. 50,000.',
    // },
    // {
    //   id: 'question_5',
    //   question: 'How much is the GST charged on forex services?',
    //   answer: (
    //     <>
    //       The following GST slabs are applicable for Forex transactions: <br />
    //       1. 0.18% of the total amount up to Rs. 100,000, subject to a minimum
    //       of Rs. 45 <br />
    //       2. Rs. 180 plus 0.09% of the total amount for an amount between Rs.
    //       1,00,000 and to Rs. 10,00,000 <br />
    //       3. Rs. 990 plus 0.018% of the total amount exceeding Rs. 10,00,000
    //     </>
    //   ),
    // },
    // {
    //   id: 'question_6',
    //   question:
    //     'What is Tax Collected at Source (TCS) and when is it deducted on my Forex transactions?',
    //   answer:
    //     'According to the RBI guidelines, Tax Collected at Source (TCS) is the tax you have to pay if your order exceeds INR 7,00,000. The tax charged will then be 5% for a taxpayer and 10% for a non-taxpayer.',
    // },
    // {
    //   id: 'question_7',
    //   question: 'What all currencies can I purchase from Muthoot FinCorp ONE?',
    //   answer: (
    //     <>
    //       Muthoot FinCorp ONE offers all major and legally accepted currencies.
    //       The list of currencies available are: U.S dollar (USD), Euro (EUR),
    //       Japanese Yen (JPY), Pound sterling (GBP), Renminbi (CNY), Australian
    //       dollar (AUD), Canadian dollar (CAD), Swiss franc (CHF), Hong Kong
    //       dollar (HKD), Singapore dollar (SGD), UAE dirham (AED), Saudi Riyal
    //       (SAR), Malaysian ringgit (MYR), Thai baht (THB) and New Zealand dollar
    //       (NZD). <br />
    //       You can get these anytime within 24* hours. However, the availability
    //       of some of these currencies can be subject to market liquidity.
    //     </>
    //   ),
    // },
    // {
    //   id: 'question_8',
    //   question: 'What is the ‘Block Rate’ feature on Muthoot FinCorp ONE?',
    //   answer:
    //     'The block rate feature on Muthoot FinCorp ONE allows you to lock-in your Forex exchange rate for two days just by paying a nominal premium  for your order.',
    // },
    // {
    //   id: 'question_9',
    //   question:
    //     'What is the ‘Buy Back Guarantee’ feature on Muthoot FinCorp ONE?',
    //   answer:
    //     'At Muthoot FinCorp ONE we give you the buy-back guarantee feature with a promise to buy your the purchased or left-over currency from you, at the same exchange rate you had purchased from us. You can do this within a period of 15 days, from the date of purchase.',
    // },
    // {
    //   id: 'question_10',
    //   question:
    //     'What is the verification process to buy, sell and reload Forex at Muthoot FinCorp ONE?',
    //   answer:
    //     'At Muthoot FinCorp ONE you can complete your KYC or verification process either through an online video-KYC or by visiting a nearby Muthoot FinCorp Forex Branch with your documents.',
    // },
  ];
};

export const outwardRemittanceFaq = (): FaqType[] => {
  return [
    {
      id: 'question_1',
      question:
        'How many days would it take for money to reach the beneficiary account?',
      answer:
        'At Muthoot FinCorp ONE all the international money transfers are completed within 24* hours by us. However, the receiving bank can sometimes take more than 24* hours to reflect the transaction into the recipient’s bank account.',
    },
    {
      id: 'question_2',
      question:
        'Why is my money not credited to the beneficiary account even in 48 hours?',
      answer: (
        <>
          When your money is not credited to the beneficiary account even in 48
          hours, it could be due to several reasons. Firstly, check if there is
          an international bank holiday, secondly, the receiving bank might be
          taking some extra time. <br />
          We suggest that you wait for one more day, and still, if your money
          isn’t credited, please contact our customer support.
        </>
      ),
    },
    {
      id: 'question_3',
      question:
        'What are the circumstances that might lead to rejection of an outward remittance request?',
      answer: (
        <>
          Your outward remittance can be rejected due to the following reasons:{' '}
          <br />
          i. If the Liberalized Remittance Scheme (LRS) of USD 2,50,000 limit
          has already been utilized <br />
          ii. If there is an insufficient balance in your account <br />
          iii. If the beneficiary country is not in RBI’s; permitted country
          list <br />
          iv. If you have entered incorrect details of the beneficiary account{' '}
          <br />
          v. If the purpose of your amount transfer not covered under LRS <br />
        </>
      ),
    },
    {
      id: 'question_4',
      question:
        'What are the documents required for making an international money transfer at Muthoot FinCorp ONE?',
      answer: (
        <>
          For international money transfer, your documents would vary for
          different purposes. Here is a list of the following: <br />
          i. To transfer funds to close relatives (‘relative’ as defined in
          Section 2(77) of the Companies Act, 2013) abroad, you will need to
          submit: - Sender: A2 form, (Form A2 is a FEMA declaration cum
          application for the purchase of foreign exchange for remittance
          purposes and mandated by RBI), address proof (Aadhar Card/Driving
          Licence/Passport or Voter ID), relationship proof (Passport/marriage
          certificate etc) - Receiver: Passport copy (with a declaration stating
          the relationship proof) <br />
          ii. When you need to transfer for medical visit, you will need to
          submit - Sender: A2 form (Form A2 is a FEMA declaration cum
          application for the purchase of foreign exchange for remittance
          purposes and mandated by RBI), Address proof (Aadhar Card/Driving
          Licence/ passport/Voter ID), relationship proof with close relative
          lose relatives (‘relative’ as defined in Section 2(77) of the
          Companies Act, 2013)Receiver: Letter from hospital and their passport
          copy <br />
          iii. To transfer funds to an educational institute, you will need to
          submit: Sender: A2 form (Form A2 is a FEMA declaration cum application
          for the purchase of foreign exchange for remittance purposes and
          mandated by RBI), Address proof (Aadhar Card/Driving
          Licence/Passport/Voter ID), relationship proof with close relative
          lose relatives (‘relative’ as defined in Section 2(77) of the
          Companies Act, 2013)Receiver: University acceptance and admission
          Letter along with the passport copy. <br />
          iv. For gift and donations you will need to submit:- Sender: -A2 form
          (Form A2 is a FEMA declaration cum application for the purchase of
          foreign exchange for remittance purposes and mandated by RBI), KYC
          documents (Aadhar Card/Driving Licence/Pan Card/Passport/Voter ID) and
          PAN Card. <br />
          Receiver: Valid Bank Account Details <br />
        </>
      ),
    },
  ];
};
